import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      id: 0,
      account_valid_to: null,
      email: '',
      has_valid_account: null,
      permissions: {},
      type: '',
      language: {
        id: 0,
        code: '',
        has_error: false
      },
      package: {
        id: 0,
        name: '',
        comments: 0,
        messages: 0,
        customers: 0,
        inquiries: 0,
        communications: 0,
        calendar: 0,
        articles: 0,
        credit_offer: 0,
      }
    },
    siteDomainEN: 'https://finpl.co.uk/',
    siteDomainPL: 'https://finhub.pl/',
  },
  actions: {
    logoutUser ({ commit }) {
      commit('setUser', {});
    }
  },
  mutations: {
    setUserID (state, id) {
      Vue.set(state.user, 'id', parseInt(id, 10));
    },
    setUserEmail (state, email) {
      Vue.set(state.user, 'email', email);
    },
    setUserType (state, type) {
      Vue.set(state.user, 'type', type);
    },
    setUserPermissions (state, permissions) {
      Vue.set(state.user, 'permissions', JSON.parse(JSON.stringify(permissions)));
    },
    setUserAccountValidTo (state, accountValidTo) {
      Vue.set(state.user, 'account_valid_to', accountValidTo);
    },
    setUserHasValidAccount (state, hasValidAccount) {
      Vue.set(state.user, 'has_valid_account', hasValidAccount);
    },
    setUserPackage (state, packageObj) {
      Vue.set(state.user, 'package', JSON.parse(JSON.stringify(packageObj)));
    },
    setUserLanguage (state, newLang) {
      Vue.set(state.user.language, 'id', newLang.id);
      Vue.set(state.user.language, 'code', newLang.code);
    },
    setUserLanguageHasError (state, hasError) {
      Vue.set(state.user, 'has_error', hasError);
    },
    setSideDomain (state, domain) {
      Vue.set(state, 'siteDomain', domain);
    }
  },
  getters: {
    getUserID: (state) => state.user.id,
    getUserEmail: (state) => state.user.email,
    getUserType: (state) => state.user.type,
    getUserPermission: (state) => (permission) => !!state.user.permissions[permission],
    getUserAccountValidTo: (state) => state.user.account_valid_to,
    getUserHasValidAccount: (state) => state.user.has_valid_account,
    getUserPackageName: (state) => state.user.package ? state.user.package.name : '-',
    getUserLanguageId: (state) => state.user.language.id,
    getUserHasLanguage: (state) => !!state.user.language.id,
    getUserLanguageHasError: (state) => !!state.user.language.has_error,
    getUserPhoneCountryCode: (state) => state.user.language.id === 2 ? 'GB' : 'PL',
    getUserHasFeature: (state) => (sectionName) => {
      if (state.user.type !== 'ADVISER') {
        return true;
      }

      if (!state.user.package) {
        return false;
      }

      return (sectionName in state.user.package) && !!state.user.package[sectionName];
    },
    getSideDomain: (state) => {
      if (state.user.language.id === 2) {
        return state.siteDomainEN;
      }

      return state.siteDomainPL;
    }
  }
});
